import { create } from "zustand";
import { AdminApi, TOKEN_KEY } from "../api/client";

export const useAuth = create((set) => ({
  token: localStorage.getItem(TOKEN_KEY) || null,
  email: null,

  async login(email, password) {
    const { token, email: adminEmail } = await AdminApi.login(email, password);
    localStorage.setItem(TOKEN_KEY, token);
    set({ token, email: adminEmail });
  },

  logout() {
    localStorage.removeItem(TOKEN_KEY);
    set({ token: null, email: null });
  },

  isAuthenticated() {
    return Boolean(localStorage.getItem(TOKEN_KEY));
  },
}));
